import styled from "styled-components";
import {useState} from "react";
import {Popover} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilter} from "@fortawesome/pro-light-svg-icons";
import MultipleSelectionFilterValues from "./MultipleSelectionFilterValues";

const Wrapper = styled.div`
  cursor: pointer;
  margin-left: 4px;
  ${props => props.isFilterActive ? 'color: #EC407A;' : 'color: #838383;'}
  transition: all 0.3s ease-in-out;
  &:hover {
    color: var(--color-table-filter-hover)
  }
`

const ContentWrapper = styled.div`
  padding: 10px 20px;
`

const MultipleSelectionFilter = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [isFilterActive, setIsFilterActive] = useState(false);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <>
            <Wrapper onClick={handleClick} isFilterActive={isFilterActive}>
                <FontAwesomeIcon icon={faFilter}/>
            </Wrapper>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <ContentWrapper>
                    <MultipleSelectionFilterValues column={props.column} setIsFilterActive={setIsFilterActive}/>
                </ContentWrapper>
            </Popover>
        </>
    )
}

export default MultipleSelectionFilter;
